import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { ServicesBento } from "../components/home/ServicesBento";
import { Statement, Process, Leader } from "../components/home/Sections";
import { CtaBand } from "../components/site/CtaBand";

export default function Home() {
  return (
    <main id="main-content" data-testid="home-page">
      <Hero />
      <Marquee />
      <Statement />
      <ServicesBento />
      <Process />
      <Leader />
      <CtaBand />
    </main>
  );
}
